/*
 唱吧 APP 通用参数 JS Bridge
 规范文档: https://s8qu5yn8sp.feishu.cn/wiki/wikcn8lZfheKp8jOu0w18oaEAmg
*/

const ua = navigator.userAgent.toLowerCase();
const isAndroid = ua.indexOf('android') > 0;
const isIOS = /iphone|ipad|ipod/.test(ua);
const isQQorWeChat = /micromessenger|qq\//.test(ua);
const isWeibo = /weibo/.test(ua);
const outChangba = (ua.indexOf('changba') < 0) || isQQorWeChat || isWeibo || /cblive/.test(ua);

const getQuery = (name, url) => {
  name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');

  if (!url) {
    url = window.location.href;
  }

  const _regexS = '[\\?&]' + name + '=([^&#]*)';
  const _regex = new RegExp(_regexS);
  const _results = _regex.exec(url);

  if (_results == null) {
    return '';
  }
  else {
    return decodeURIComponent(_results[1].replace(/\+/g, ' '));
  }
};

const getGlobalParamsForAndroid = () => {
  const result = window.changbaCaller?.getDefaultParams?.() ?? '{}';

  try {
    return JSON.parse(result);
  }
  catch (e) {
    return {};
  }
};

const getRandom = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值
};

const getGlobalParamsForIOS = () => new Promise((resolve) => {
  const callbackName = '__webkitChangbaCallerGetDefaultParams' + String(new Date().getTime()) + String(getRandom(1000, 9999));
  const windowTop = window.top || window
  windowTop[callbackName] = function(result) {
    try {
      resolve(JSON.parse(result));
    }
    catch (e) {
      resolve({});
    }
    windowTop[callbackName] = null;
  }

  if (windowTop.webkit?.messageHandlers?.getDefaultParams) {
    windowTop.webkit.messageHandlers.getDefaultParams.postMessage(callbackName);
  }
  else {
    resolve({});
  }
});

// 各种兼容性处理
const compatibility = (params) => {
  if (!params.macaddress && params.n4) {
    // 新版本没有 macaddress 使用 n4 代替
    params.macaddress = params.n4;
  }
  else if (params.macaddress && !params.n4) {
    // 旧版本没有 n4 使用 macaddress 代替
    params.n4 = params.macaddress;
  }
  else if (!params.macaddress && !params.n4) {
    const macAddress = getQuery('macaddress')
    const deviceId = getQuery('deviceid');
    const n4 = getQuery('global_params_n4');

    params.n4 = n4 || macAddress || deviceId;
    params.macaddress = params.n4;
  }

  if (!params.userId) {
    params.userId = getQuery('curuserid');
  }

  if (!params.token) {
    params.token = getQuery('token');
  }

  if (!params.appVersion) {
    const match = /\s+changba\/([\d.]+)/.exec(ua);
    if (match) {
      params.appVersion = match[1];
    }
  }

  if (!params.smdeviceid) {
    params.smdeviceid = getQuery('shuMeiId');
  }

  if (!params.longitude) {
    params.longitude = getQuery('longitude');
  }

  if (!params.latitude) {
    params.latitude = getQuery('latitude');
  }

  params.smDeviceId = params.smdeviceid;

  params.deviceId = params.n4 || params.uuid;

  return params;
};

export default function getGlobalParams() {
  return new Promise((resolve) => {
    if (outChangba) {
      return resolve(compatibility({}));
    }

    if (isAndroid) {
      return resolve(compatibility(getGlobalParamsForAndroid()));
    }
    else if (isIOS) {
      return getGlobalParamsForIOS().then((result) => {
        resolve(compatibility(result));
      });
    }
    else {
      return resolve(compatibility({}));
    }
  });
}
